import { z } from "zod";

export const EnrolGroupeDataSchema = z.object({
  type: z.string(),
  matriculeProprietaire: z.string(),
  matricule: z.string(),
  sexe: z.string(),
  espece: z.string(),
  nombrePartiel: z.number(),
  encrypte: z.boolean(),
  sousLot: z.boolean(),
  typeEnrolement: z.string(),
});

export const EnrolUniqueDataSchema = z.object({
  type: z.string(),
  animalType: z.string(),
  proprietaire: z.object({}),
  matricule: z.string(),
  sexe: z.string(),
  // espece: z.string(),
  // nombrePartiel: z.number(),
  // encrypte: z.boolean(),
  sousLot: z.boolean(),
  // typeEnrolement: z.string().optional(),
  /// uniquement pour les enrolement unique
  nom: z.string(),
  poids: z.number().optional(),
  taille: z.number().optional(),
  couleur: z.string().optional(),
  dateNaissance: z.string().optional(),
  especeOrigine: z.string().optional(),
  laitiere: z.boolean().optional(),
});
